/**
 * KatieCoin Treasure Hunt — PDP emblem paint (ONE-PHOTO FIX 2026-09-20)
 * Fetches GET /apps/katiecoins/hunt/today?handle&product_id&media_count
 * HARD LOCK: exactly ONE product photo (2|3|4) may show a KatieCoin emblem.
 * Never photo 1. Never thumbnails. Never multiple positions on the same PDP.
 *
 * HARD LOCK 2026-09-20 (Katie):
 *   - Density ~1/5 (server day-hash); mint +20 usual / occasional +100 (server)
 *   - Toast at click: live server toast "+N KatieCoins — emblem found!"
 *   - Guest: fun toast without banking; NEVER redirect to /account/login
 *   - Hover = soft cue only; never value-badge art
 *   - ONE emblem photo per product (this fix)
 */
(function () {
  if (window.__klTreasureHuntBooted) return;
  window.__klTreasureHuntBooted = true;

  var DEFAULT_PROXY = '/apps/katiecoins';
  var ASSET_BASE = '';
  var TOAST_ALREADY = 'Already yours ♡';
  var TOAST_GUEST = 'Sign in to collect KatieCoins';

  /** Product-level paint lock: handle|id → chosen image_position (or 'none') */
  var __klHuntPainted = window.__klHuntPainted || (window.__klHuntPainted = Object.create(null));
  var __klHuntInflight = window.__klHuntInflight || (window.__klHuntInflight = Object.create(null));

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function assetUrl(name) {
    if (!name) return '';
    if (/^https?:\/\//i.test(name) || name.charAt(0) === '/') return name;
    var base = ASSET_BASE.replace(/\/+$/, '');
    return base + '/' + name.replace(/^\//, '');
  }

  function emblemSrc(spot, desktop) {
    var claimed = !!(spot && spot.claimed);
    if (claimed) {
      return assetUrl(
        desktop
          ? (spot.asset_claimed_desktop || 'katiecoin-overlay-128-claimed.png')
          : (spot.asset_claimed || 'katiecoin-overlay-96-claimed.png')
      );
    }
    return assetUrl(
      desktop
        ? (spot.asset_unclaimed_desktop || 'katiecoin-overlay-128.png')
        : (spot.asset_unclaimed || 'katiecoin-overlay-96.png')
    );
  }

  function sparkleSrc(desktop) {
    return assetUrl(desktop ? 'katiecoin-sparkle-only-128.webp' : 'katiecoin-sparkle-only-96.webp');
  }

  function toastFromCredit(data) {
    if (data && data.toast) return String(data.toast);
    var minted = data && (data.minted != null ? data.minted : data.credited != null ? data.credited : data.coins);
    if (minted != null && Number(minted) > 0) {
      return '+' + Number(minted) + ' KatieCoins — emblem found!';
    }
    return '+20 KatieCoins — emblem found!';
  }

  function isDesktop() {
    try { return window.matchMedia('(min-width: 750px)').matches; } catch (e) { return false; }
  }

  function productKey(handle, productId) {
    return String(productId || handle || 'unknown').trim() || 'unknown';
  }

  /** Remove every hunt emblem on the PDP before (re)paint. */
  function clearAllEmblems() {
    $all('.kl-hunt-emblem').forEach(function (el) {
      try { el.remove(); } catch (e) { /* ignore */ }
    });
  }

  /**
   * Find ALL main-media hosts for Shopify position N (1-based).
   * Prefer [data-kl-hunt-photoN] on .product-gallery__media only.
   * NEVER thumbnails. NEVER photo 1.
   * Returns every matching main slide (mobile + desktop galleries).
   */
  function findMainPhotoHosts(position) {
    var pos = Number(position) || 2;
    if (pos < 2) pos = 2;
    if (pos > 4) pos = 4;

    var hosts = [];
    var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

    function pushHost(el) {
      if (!el) return;
      if (seen) {
        if (seen.has(el)) return;
        seen.add(el);
      } else if (hosts.indexOf(el) !== -1) {
        return;
      }
      hosts.push(el);
    }

    // 1) Preferred: explicit hunt hooks on main media slides only
    $all('[data-kl-hunt-photo' + pos + ']').forEach(function (el) {
      if (el.hasAttribute('hidden')) return;
      if (el.classList.contains('product-gallery__thumbnail')) return;
      if (el.closest && el.closest('.product-gallery__thumbnail-list, .product-gallery__thumbnail-scroller, product-gallery-navigation')) return;
      if (el.tagName === 'BUTTON') return;
      if (!el.querySelector('img, video, .media, .product-gallery__media')) {
        // allow slide that IS the media container even if img not yet lazy-loaded
        if (!el.classList.contains('product-gallery__media') && !el.classList.contains('product__media')) return;
      }
      pushHost(el);
    });

    if (hosts.length) return hosts;

    // 2) Fallback: data-media-position on main media only (exclude thumbnails)
    $all('[data-media-position="' + pos + '"]').forEach(function (el) {
      if (el.hasAttribute('hidden')) return;
      if (el.classList.contains('product-gallery__thumbnail')) return;
      if (el.tagName === 'BUTTON') return;
      if (el.closest && el.closest('.product-gallery__thumbnail-list, .product-gallery__thumbnail-scroller, product-gallery-navigation')) return;
      if (el.hasAttribute('data-kl-foil-slide')) return;
      if (!(
        el.classList.contains('product-gallery__media') ||
        el.classList.contains('product__media') ||
        el.classList.contains('product-media')
      )) return;
      pushHost(el);
    });

    if (hosts.length) return hosts;

    // 3) Last resort: index into each product-gallery carousel (not thumbnails)
    $all('product-gallery, [data-product-media-list], .product__media-list, .product-gallery').forEach(function (gallery) {
      var mediaItems = $all(
        '.product-gallery__media, .product__media, .product-media',
        gallery
      ).filter(function (el) {
        return !el.hasAttribute('data-kl-foil-slide') &&
          !el.classList.contains('product-gallery__thumbnail') &&
          !el.hasAttribute('hidden');
      });
      var idx = pos - 1;
      if (mediaItems.length > idx) pushHost(mediaItems[idx]);
    });

    return hosts;
  }

  function ensureRelative(el) {
    if (!el) return;
    var cs = window.getComputedStyle(el);
    if (cs.position === 'static') el.style.position = 'relative';
  }

  /** HARD LOCK: toast at click location (not bottom-of-page). */
  var _lastPointer = { x: null, y: null };
  function rememberPointer(ev) {
    try {
      if (!ev) return;
      if (ev.clientX != null && ev.clientY != null) {
        _lastPointer.x = Number(ev.clientX);
        _lastPointer.y = Number(ev.clientY);
        return;
      }
      var t = ev.changedTouches && ev.changedTouches[0];
      if (t) {
        _lastPointer.x = Number(t.clientX);
        _lastPointer.y = Number(t.clientY);
      }
    } catch (e) {}
  }
  function placeToastNearClick(el, x, y) {
    if (!el) return;
    var pad = 12;
    var w = el.offsetWidth || 280;
    var h = el.offsetHeight || 48;
    var vw = window.innerWidth || 360;
    var vh = window.innerHeight || 640;
    var left = (x != null && !isNaN(x) ? x : vw / 2) - w / 2;
    var top = (y != null && !isNaN(y) ? y : vh * 0.4) - h - 16;
    if (top < pad) top = (y != null ? y : vh * 0.4) + 16;
    left = Math.max(pad, Math.min(left, vw - w - pad));
    top = Math.max(pad, Math.min(top, vh - h - pad));
    el.style.position = 'fixed';
    el.style.left = left + 'px';
    el.style.top = top + 'px';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.transform = 'none';
    el.style.zIndex = '99999';
  }

  function showToast(msg, ev) {
    rememberPointer(ev);
    var existing = $('#kl-hunt-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'kl-hunt-toast';
    t.className = 'kl-kc-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg || '';
    t.style.cssText = [
      'z-index:99999', 'max-width:min(92vw,360px)', 'padding:12px 18px',
      'border-radius:999px', 'background:rgba(255,248,251,0.96)',
      'border:1.5px solid rgba(201,164,106,0.85)', 'color:#c45d86',
      'font:600 14px/1.35 Georgia,"Palatino Linotype",serif',
      'box-shadow:0 8px 24px rgba(90,58,72,0.15)', 'text-align:center',
      'pointer-events:none', 'margin:0'
    ].join(';');
    document.body.appendChild(t);
    placeToastNearClick(t, _lastPointer.x, _lastPointer.y);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 3200);
  }

  function paintSpot(container, spot, opts) {
    if (!container || !spot) return;
    ensureRelative(container);
    var id = spot.spot_id || ('guest-' + (spot.product_handle || 'x') + '-' + spot.xPct);
    var existing = container.querySelector('.kl-hunt-emblem[data-spot="' + id + '"]');
    if (existing) existing.remove();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kl-hunt-emblem';
    btn.setAttribute('data-spot', id);
    btn.setAttribute('data-image-position', String(spot.image_position || 2));
    btn.setAttribute('aria-label', spot.claimed ? 'KatieCoin already found' : 'KatieCoin Treasure Hunt emblem');
    if (opts && opts.stagingMock) btn.setAttribute('data-staging-mock', 'true');

    var size = Math.max(4, Math.min(14, Number(spot.sizePct) || 8));
    btn.style.cssText = [
      'position:absolute',
      'left:' + Number(spot.xPct) + '%',
      'top:' + Number(spot.yPct) + '%',
      'width:' + size + '%',
      'max-width:72px',
      'min-width:36px',
      'aspect-ratio:1/1',
      'transform:translate(-50%,-50%)',
      'padding:0', 'border:0', 'background:transparent',
      'cursor:' + (spot.claimed || spot.sign_in_to_hunt || spot.shimmer ? 'default' : 'pointer'),
      'z-index:5', 'line-height:0',
      'filter:drop-shadow(0 2px 6px rgba(90,58,72,0.25))',
      'opacity:' + (spot.shimmer ? '0.55' : '1')
    ].join(';');

    var img = document.createElement('img');
    img.alt = '';
    img.draggable = false;
    img.width = isDesktop() ? 128 : 96;
    img.height = img.width;
    img.src = emblemSrc(spot, isDesktop());
    img.className = 'kl-hunt-emblem__coin';
    img.style.cssText = 'display:block;width:100%;height:auto;pointer-events:none;position:relative;z-index:1;';
    btn.appendChild(img);

    var sparkle = document.createElement('img');
    sparkle.className = 'kl-hunt-emblem__sparkle';
    sparkle.alt = '';
    sparkle.draggable = false;
    sparkle.setAttribute('aria-hidden', 'true');
    sparkle.src = sparkleSrc(isDesktop());
    sparkle.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;pointer-events:none;z-index:2;';
    if (!spot.claimed && !spot.shimmer) {
      btn.classList.add('kl-hunt-emblem--sparkle');
    }
    btn.appendChild(sparkle);

    var collectArmed = true;
    function tryCollect(e) {
      rememberPointer(e);
      if (e && e.preventDefault) e.preventDefault();
      if (!collectArmed) return;
      collectArmed = false;
      setTimeout(function () { collectArmed = true; }, 800);

      if (spot.shimmer || spot.sign_in_to_hunt) {
        showToast(TOAST_GUEST, e);
        return;
      }
      if (spot.claimed) {
        showToast(TOAST_ALREADY, e);
        return;
      }
      if (spot.spot_id) {
        claimSpot(spot, btn, img, opts, e);
      }
    }

    btn.addEventListener('mouseenter', function () {
      if (!spot.claimed) btn.classList.add('kl-hunt-emblem--hover');
    });
    btn.addEventListener('mouseleave', function () {
      btn.classList.remove('kl-hunt-emblem--hover');
    });
    btn.addEventListener('click', function (e) { tryCollect(e); });
    btn.addEventListener('touchend', function (e) { tryCollect(e); }, { passive: false });

    container.appendChild(btn);
  }

  function claimSpot(spot, btn, img, opts, ev) {
    if (btn.getAttribute('data-claiming') === '1') return;
    btn.setAttribute('data-claiming', '1');

    var proxy = ((opts && opts.proxy) || DEFAULT_PROXY).replace(/\/+$/, '');
    var url = proxy + '/hunt/claim';

    function finishClaimed(data) {
      spot.claimed = true;
      img.src = emblemSrc(spot, isDesktop());
      btn.classList.remove('kl-hunt-emblem--sparkle');
      btn.style.cursor = 'default';
      if (data && data.already) {
        showToast(TOAST_ALREADY, ev);
      } else if (data && (data.fun_mode || data.credited === 0) && data.toast) {
        showToast(String(data.toast), ev);
      } else {
        showToast(toastFromCredit(data), ev);
      }
      try {
        document.dispatchEvent(new CustomEvent('kl:hunt-claimed', { detail: data || {} }));
        $all('[data-kl-purse-coins]').forEach(function (el) {
          if (data && data.balance != null) el.textContent = String(data.balance);
        });
      } catch (err) { /* ignore */ }
      btn.removeAttribute('data-claiming');
    }

    if (opts && opts.stagingMock) {
      finishClaimed({
        ok: true,
        staging_mock: true,
        toast: '+20 KatieCoins — emblem found!',
        minted: 20,
        credited: 20,
        balance: null
      });
      return;
    }

    var body = {
      spot_id: spot.spot_id,
      product_handle: spot.product_handle || (opts && opts.handle) || undefined,
      product_id: spot.product_id || (opts && opts.productId) || undefined,
      media_count: opts && opts.mediaCount != null ? opts.mediaCount : undefined
    };

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        return { res: res, data: data };
      });
    }).then(function (pack) {
      var data = pack.data || {};
      if (pack.res.status === 401 || data.error === 'login_required' || data.reason === 'login_required') {
        showToast((data && data.toast) || TOAST_GUEST, ev);
        btn.removeAttribute('data-claiming');
        return;
      }
      if (data.ok || data.already) {
        finishClaimed(data);
        return;
      }
      showToast(data.message || data.error || 'Could not claim — try again', ev);
      btn.removeAttribute('data-claiming');
    }).catch(function () {
      showToast('Hunt quiet — try again soon', ev);
      btn.removeAttribute('data-claiming');
    });
  }

  /**
   * HARD LOCK: at most ONE spot for this product; paint ONLY that image_position
   * on main media slides (all galleries, same index). Never thumbnails / photo 1.
   */
  function applyOneSpot(spots, opts, meta) {
    if (meta && meta.stagingMock) opts.stagingMock = true;

    var handle = opts.handle || '';
    var productId = opts.productId || '';
    var key = productKey(handle, productId);

    // Already painted this product this page life — do not paint a second position
    if (__klHuntPainted[key] != null) return;

    var matched = (spots || []).filter(function (spot) {
      if (!spot) return false;
      if (handle && spot.product_handle && spot.product_handle !== handle) return false;
      if (productId && spot.product_id && String(spot.product_id) !== String(productId) && spot.product_handle !== handle) {
        return false;
      }
      return true;
    });

    // At most one spot — first matching handle/id
    var spot = matched[0] || null;
    if (!spot) {
      __klHuntPainted[key] = 'none';
      return;
    }

    var pos = Number(spot.image_position) || 2;
    if (pos < 2) pos = 2;
    if (pos > 4) pos = 4;
    spot.image_position = pos;

    clearAllEmblems();

    var hosts = findMainPhotoHosts(pos);
    if (!hosts.length) {
      __klHuntPainted[key] = 'none';
      return;
    }

    hosts.forEach(function (host) {
      paintSpot(host, spot, opts);
    });

    __klHuntPainted[key] = pos;
  }

  function bootRoot(root) {
    if (!root || root.getAttribute('data-booted') === '1') return;
    root.setAttribute('data-booted', '1');

    ASSET_BASE = root.getAttribute('data-asset-base') || ASSET_BASE || '';
    var proxy = (root.getAttribute('data-proxy') || DEFAULT_PROXY).replace(/\/+$/, '');
    var handle = (root.getAttribute('data-product-handle') || '').trim();
    var productId = (root.getAttribute('data-product-id') || '').trim();
    var mediaCount = Number(root.getAttribute('data-media-count') || 0) || 0;
    var stagingMock = root.getAttribute('data-staging-mock') === 'true';
    var loginUrl = root.getAttribute('data-login') || '/account/login';
    var key = productKey(handle, productId);

    // Product-level guard: another root already painted or is fetching
    if (__klHuntPainted[key] != null) return;
    if (__klHuntInflight[key]) return;
    __klHuntInflight[key] = true;

    var opts = {
      proxy: proxy,
      stagingMock: stagingMock,
      loginUrl: loginUrl,
      handle: handle,
      productId: productId,
      mediaCount: mediaCount
    };

    function done() {
      __klHuntInflight[key] = false;
    }

    if (stagingMock) {
      try {
        applyOneSpot([{
          spot_id: 'staging-mock-1',
          product_handle: handle || 'staging-demo',
          product_id: productId || null,
          image_position: 2,
          xPct: 78,
          yPct: 72,
          sizePct: 7,
          coin_value: 20,
          claimed: false
        }], opts, { stagingMock: true });
        root.setAttribute('data-staging-mock', 'true');
      } finally {
        done();
      }
      return;
    }

    var qs = [];
    if (handle) qs.push('handle=' + encodeURIComponent(handle));
    if (productId) qs.push('product_id=' + encodeURIComponent(productId));
    if (mediaCount) qs.push('media_count=' + encodeURIComponent(String(mediaCount)));
    var todayUrl = proxy + '/hunt/today' + (qs.length ? ('?' + qs.join('&')) : '');

    fetch(todayUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('hunt_' + res.status);
      return res.json();
    }).then(function (data) {
      if (!data || data.ok === false) throw new Error('hunt_bad');
      // Re-check race: another root may have finished while we fetched
      if (__klHuntPainted[key] != null) return;
      applyOneSpot(data.spots || [], opts, {});
    }).catch(function () {
      /* soft-fail quiet — no mock on live */
      if (__klHuntPainted[key] == null) __klHuntPainted[key] = 'none';
      root.setAttribute('data-hunt-quiet', 'true');
    }).then(done, done);
  }

  function bootAll() {
    $all('[data-kl-treasure-hunt]').forEach(bootRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function () {
    // Allow section re-load in theme editor: clear product locks for visible roots
    $all('[data-kl-treasure-hunt]').forEach(function (root) {
      root.removeAttribute('data-booted');
      var handle = (root.getAttribute('data-product-handle') || '').trim();
      var productId = (root.getAttribute('data-product-id') || '').trim();
      var key = productKey(handle, productId);
      delete __klHuntPainted[key];
      delete __klHuntInflight[key];
    });
    clearAllEmblems();
    bootAll();
  });
})();
